import { useAppSelector } from "features/common/hooks/useReduxHooks";
import { request } from "libs/axios";
import { useQuery } from "react-query";
import { gamesTypes } from "../types/gamesTypes";
import {
  StatisticsGameOthers,
  AttemptResponse,
} from "features/common/interfaces/apis/responses/games/StatisticsResponse.d";

export const useAttemptsApi = (
  id: number | null,
  resource: gamesTypes,
  table: "attempts" | "visitors"
) => {
  const { currAppToken } = useAppSelector((state) => state.appsAuth);
  const {
    pagnation: { page, perPage },
    search,
  } = useAppSelector((state) => state.games[resource].statisticsPage.attempts);

  return useQuery(
    [`Attempts-${resource}`, id, search],
    () => {
      return request<AttemptResponse[], StatisticsGameOthers>({
        url:
          resource === "scratch_ticket"
            ? `/scratch-tickets/game-attempts/${id}`
            : resource === "scratch_grid"
            ? `/scratch-grids/game-attempts/${id}`
            : resource === "number_guess"
            ? `/number-guesses/game-attempts/${id}`
            : "",
        method: "GET",
        headers: {
          Authorization: `Bearer ${currAppToken}`,
        },
        params: {
          filter: {
            search: search,
          },
          items_per_page: perPage,
          page: page,
        },
      });
    },
    {
      select: (data) => {
        return data.data;
      },
      enabled: table === "attempts",
    }
  );
};
